import type { IValidationTargetOptions } from "./interface";

/**
 * Input shape used to resolve validation options.
 */
export interface IValidationOptionsInput {
  validationOptions?:
    | IValidationTargetOptions
    | ((values: Record<string, string>) => IValidationTargetOptions | undefined);
}

/**
 * Resolves validation options for an input from static or computed values.
 *
 * @param input - Input definition containing static or computed validation options.
 * @param values - Current merged values used when validation options are computed.
 * @returns Validation target options for the input.
 */
export const getValidationOptions = (
  input: IValidationOptionsInput,
  values: Record<string, string>,
): IValidationTargetOptions | undefined =>
  typeof input.validationOptions === "function"
    ? input.validationOptions(values)
    : input.validationOptions;
